import React, { useState, useContext, useEffect } from 'react'
import { statusContext, seedFilters, seedContent, initialItems } from './config';
import List from './CheckboxList'

const Filters = (props) => {
  const status = useContext(statusContext)
  const content = useContext(seedContent)
  const seed = useContext(seedFilters)
  const initialEls = useContext(initialItems)

  const setStatus = (root, status) => {
    root.status = status;
    if (Array.isArray(root.items)) {
      return root.items.forEach((item) => {
        setStatus(item, status);
      });
    }
  };

  const computeStatus = (items) => {
    let checked = 0;
    let indeterminate = 0;

    items.forEach((item) => {
      if (item.status && item.status === status.checked) checked++;
      if (item.status && item.status === status.indeterminate) indeterminate++;
    });

    if (checked === items.length) {
      return status.checked;
    } else if (checked > 0 || indeterminate > 0) {
      return status.indeterminate;
    }
  };

  // Depth-first traversal
  const traverse = (root, needle, status) => {
    let id;
    let items;
    if (Array.isArray(root)) {
      items = root
    } else {
      id = root.id;
      items = root.items;
    }

    // return if needle is found
    // we don't have to compute the status of the items if root.id === needle
    if (id === needle) {
      return setStatus(root, status);
    }

    if (!items) {
      return root;
    } else {
      items.forEach((item) => traverse(item, needle, status));
      root.status = computeStatus(items);
    }
  };

  const [items, setItems] = useState(seed[props.filterType])

  const compute = (checkboxId, status) => {
    traverse(items, checkboxId, status);
    setItems(items.slice());
  };

  const setParents = (filters) => {
    // let sortedFilters = []
    
    filters.forEach((filter) => {
      filter.status = ((props.filterType === 'categories' && initialEls.categories.includes(filter.id)) || props.filterType !== 'categories') ? 1 : 0  // sneaky little checkbox workaround to make everything not checked by default

      if (filter.parent) {
        const parentId = filter.parent
        const parentIndex = filters.findIndex(filter => filter.id === parentId)
        if (filters[parentIndex]) {
          if (!filters[parentIndex].items) filters[parentIndex].items = []
          filters[parentIndex].items.push(filter)
          filter.hasParent = 1;
        }
      }
    })
    return filters.filter(f => !f.hasParent)
  }

  useEffect(() => {
    setItems((prevState) => {
      if (prevState[0].processed) {
        return prevState
      }
      const sortedFilters = setParents(props.filterData)
      prevState[0].items = [...prevState[0].items, ...sortedFilters]
      prevState[0].processed = true
      return prevState
    })
  }, [props.filterData])

  return (
    <div className="sopa-map--filter-panel">
      <h3 className="sopa-map--filter-panel_heading">{content[props.filterType].heading}</h3>
        <List initialItems={initialItems} initialLoad={props.initialLoad} setActiveFilter={props.setActiveFilter} initiallyActive={props.initiallyActive} filterType={props.filterType} items={items} map={props.map} compute={compute} setClosureActive={props.setClosureActive} closureActive={props.closureActive} setClosureDetails={props.setClosureDetails}
        />
      </div>
  );
}

export default Filters
